/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BulkUpload
 */
export interface BulkUpload {
  /**
   *
   * @type {string}
   * @memberof BulkUpload
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof BulkUpload
   */
  readonly fieldworkFile?: string;
  /**
   *
   * @type {string}
   * @memberof BulkUpload
   */
  readonly labFile?: string;
  /**
   *
   * @type {string}
   * @memberof BulkUpload
   */
  readonly measurementTvpFile?: string;
  /**
   *
   * @type {Date}
   * @memberof BulkUpload
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof BulkUpload
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof BulkUpload
   */
  projectNumber: string;
  /**
   * Determines which process/task to start.
   * @type {BulkUploadBulkUploadTypeEnum}
   * @memberof BulkUpload
   */
  bulkUploadType?: BulkUploadBulkUploadTypeEnum;
  /**
   *
   * @type {BulkUploadRequestTypeEnum}
   * @memberof BulkUpload
   */
  requestType?: BulkUploadRequestTypeEnum;
  /**
   * Optional json field to add extra data that is not provided within the files, but is required in the processing of the files.
   * @type {object}
   * @memberof BulkUpload
   */
  metadata?: object;
  /**
   *
   * @type {object}
   * @memberof BulkUpload
   */
  sourcedocumentData?: object;
  /**
   *
   * @type {BulkUploadStatusEnum}
   * @memberof BulkUpload
   */
  status?: BulkUploadStatusEnum;
  /**
   *
   * @type {string}
   * @memberof BulkUpload
   */
  log?: string;
  /**
   *
   * @type {number}
   * @memberof BulkUpload
   */
  progress?: number | null;
  /**
   *
   * @type {string}
   * @memberof BulkUpload
   */
  dataOwner?: string | null;
}

/**
 * @export
 */
export const BulkUploadBulkUploadTypeEnum = {
  Gar: "GAR",
  Gld: "GLD",
  Gmn: "GMN",
} as const;
export type BulkUploadBulkUploadTypeEnum =
  (typeof BulkUploadBulkUploadTypeEnum)[keyof typeof BulkUploadBulkUploadTypeEnum];

/**
 * @export
 */
export const BulkUploadRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type BulkUploadRequestTypeEnum =
  (typeof BulkUploadRequestTypeEnum)[keyof typeof BulkUploadRequestTypeEnum];

/**
 * @export
 */
export const BulkUploadStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type BulkUploadStatusEnum = (typeof BulkUploadStatusEnum)[keyof typeof BulkUploadStatusEnum];

/**
 * Check if a given object implements the BulkUpload interface.
 */
export function instanceOfBulkUpload(value: object): value is BulkUpload {
  if (
    (!("projectNumber" in (value as Record<string, any>)) &&
      !("project_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectNumber"] === undefined &&
      (value as Record<string, any>)["project_number"] === undefined)
  )
    return false;
  return true;
}

export function BulkUploadFromJSON(json: any): BulkUpload {
  return BulkUploadFromJSONTyped(json, false);
}

export function BulkUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpload {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    fieldworkFile: json["fieldwork_file"] == null ? undefined : json["fieldwork_file"],
    labFile: json["lab_file"] == null ? undefined : json["lab_file"],
    measurementTvpFile:
      json["measurement_tvp_file"] == null ? undefined : json["measurement_tvp_file"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    projectNumber: json["project_number"],
    bulkUploadType: json["bulk_upload_type"] == null ? undefined : json["bulk_upload_type"],
    requestType: json["request_type"] == null ? undefined : json["request_type"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    sourcedocumentData:
      json["sourcedocument_data"] == null ? undefined : json["sourcedocument_data"],
    status: json["status"] == null ? undefined : json["status"],
    log: json["log"] == null ? undefined : json["log"],
    progress:
      json["progress"] === undefined
        ? undefined
        : json["progress"] === null
        ? null
        : json["progress"],
    dataOwner:
      json["data_owner"] === undefined
        ? undefined
        : json["data_owner"] === null
        ? null
        : json["data_owner"],
  };
}

export function BulkUploadToJSON(json: any): BulkUpload {
  return BulkUploadToJSONTyped(json, false);
}

export function BulkUploadToJSONTyped(
  value?: Omit<
    BulkUpload,
    "uuid" | "fieldwork_file" | "lab_file" | "measurement_tvp_file" | "created" | "updated"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    project_number: value["projectNumber"],
    bulk_upload_type: value["bulkUploadType"],
    request_type: value["requestType"],
    metadata: value["metadata"],
    sourcedocument_data: value["sourcedocumentData"],
    status: value["status"],
    log: value["log"],
    progress: value["progress"],
    data_owner: value["dataOwner"],
  };
}
